export default __webpack_public_path__ + "static/media/redness.6f71baff.svg";